import { ArrowLeft, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <main className="not-found-page">
      <Sparkles />
      <p>404 · Beyond the mapped sky</p>
      <h1>This page could not be found.</h1>
      <Link className="button button-gold" to="/">
        <ArrowLeft /> Return home
      </Link>
    </main>
  );
}
